// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { Resources } from "../../../Commons/properties/Resources.js";
import { TerceraButton } from "../../elements/TerceraButton.js";

export let VideoWidgetButton = TerceraButton.extend({
    data: function ()
    {
        return {
            text: '',
            liveStreamOnAir: false,                         // If there are live streams now, then the button will have a different text and view: js-button-video-widget.live

            terceraButtonStyle: 'js-button-video-widget'
        }
    },
    defaultBtnTextKey: 'panel.VideoWidget',
    tooltipKey: 'panel.VideoWidget.tt'
})

VideoWidgetButton.prototype.getType = function () { return 'VideoWidgetButton' };

VideoWidgetButton.prototype.oncomplete = function ()
{
    TerceraButton.prototype.oncomplete.apply(this);

    this.observe('liveStreamOnAir', this.onLiveStreamOnAirChanged);
    this.localize();
}

VideoWidgetButton.prototype.localize = function ()
{
    this.set({ text: Resources.getResource(this.defaultBtnTextKey) });
}

VideoWidgetButton.prototype.onLiveStreamOnAirChanged = function (value)
{
    this.set({
        terceraButtonStyle: 'js-button-video-widget' + (value ? ' live' : ''),      // The initiative (logic borrowed from the Ideas panel button - flashing upon the emergence of new ideas) with the flashing button when fresh live streams appear was rejected in #115019. Replace ' live' with ' live new' to return if need.
        text: Resources.getResource(this.defaultBtnTextKey)
    });
}

VideoWidgetButton.prototype.ChangeBlinkStatus = function (liveStreamOnAir)
{
    this.set('liveStreamOnAir', liveStreamOnAir);
}